import { useState } from "react";
import { useDispatch } from "react-redux";
import { HerschrijfBeschrijving } from "../Reducers/items/actions";
import { message } from "../../../Reducers/loading/actions";

const AITextField = ({ input, meta, label, trcid, fieldType }) => {
  const [isRewriting, setIsRewriting] = useState(false);
  const [suggestion, setSuggestion] = useState(null);
  const [lastUsage, setLastUsage] = useState(null);
  const [originalValue, setOriginalValue] = useState(null);
  const dispatch = useDispatch();

  const handleAIRewrite = async () => {
    if (!input.value || input.value.trim() === "") {
      dispatch(message(3000, "warning", "Er is geen tekst om te herschrijven"));
      return;
    }

    setIsRewriting(true);
    setOriginalValue(input.value);

    try {
      const result = await dispatch(HerschrijfBeschrijving(trcid, fieldType, input.value, false));

      if (result.success) {
        // Store the suggestion instead of directly updating
        setSuggestion(result.rewrittenText);
        setLastUsage(result.usage);

        dispatch(message(5000, "success", `AI suggestie gegenereerd! (${result.usage.total_tokens} tokens gebruikt)`));
      } else {
        dispatch(message(4000, "error", result.message || "Fout bij het herschrijven van tekst"));
      }
    } catch (error) {
      console.error("Error rewriting:", error);
      dispatch(message(4000, "error", "Er is een fout opgetreden bij het herschrijven"));
    } finally {
      setIsRewriting(false);
    }
  };

  const handleAcceptSuggestion = () => {
    if (suggestion) {
      input.onChange(suggestion);
      setSuggestion(null);
      setLastUsage(null);
      setOriginalValue(null);
      dispatch(message(3000, "success", "AI suggestie geaccepteerd"));
    }
  };

  const handleRejectSuggestion = () => {
    setSuggestion(null);
    setLastUsage(null);
    setOriginalValue(null);
    dispatch(message(3000, "info", "AI suggestie geweigerd"));
  };

  return (
    <div className="form-group">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <label className="control-label" style={{ margin: 0 }}>
          {label}
          {meta.error && meta.touched && <span className="text-danger"> - {meta.error}</span>}
        </label>

        {!suggestion && (
          <button
            type="button"
            className="btn btn-info btn-sm"
            onClick={handleAIRewrite}
            disabled={isRewriting || !input.value}
            title="Genereer AI suggestie"
          >
            {isRewriting ? (
              <>
                <i className="fa fa-spinner fa-spin"></i> AI genereert suggestie...
              </>
            ) : (
              <>
                <i className="fa fa-magic"></i> AI Suggestie
              </>
            )}
          </button>
        )}
      </div>

      <div style={{ marginBottom: '10px' }}>
        <textarea
          {...input}
          className="form-control"
          rows="4"
          disabled={isRewriting || suggestion !== null}
        />
      </div>

      {suggestion && (
        <div className="box box-warning" style={{ marginTop: '10px', marginBottom: '10px' }}>
          <div className="box-header with-border">
            <h3 className="box-title">
              <i className="fa fa-lightbulb-o"></i> AI Suggestie
            </h3>
          </div>
          <div className="box-body">
            <div style={{ marginBottom: '10px' }}>
              <strong>Origineel:</strong>
              <div className="well well-sm" style={{ marginTop: '5px', backgroundColor: '#f9f9f9' }}>
                {originalValue}
              </div>
            </div>
            <div style={{ marginBottom: '10px' }}>
              <strong>AI Suggestie:</strong>
              <div className="well well-sm" style={{ marginTop: '5px', backgroundColor: '#fcf8e3' }}>
                {suggestion}
              </div>
            </div>
            {lastUsage && (
              <div className="alert alert-info" style={{ padding: '8px', marginBottom: '10px' }}>
                <small>
                  <i className="fa fa-info-circle"></i> <strong>Token gebruik:</strong> {lastUsage.total_tokens} tokens
                  (Prompt: {lastUsage.prompt_tokens}, Completion: {lastUsage.completion_tokens})
                </small>
              </div>
            )}
            <div>
              <button
                type="button"
                className="btn btn-success btn-sm"
                onClick={handleAcceptSuggestion}
                style={{ marginRight: '5px' }}
              >
                <i className="fa fa-check"></i> Accepteren
              </button>
              <button
                type="button"
                className="btn btn-default btn-sm"
                onClick={handleRejectSuggestion}
              >
                <i className="fa fa-times"></i> Weigeren
              </button>
            </div>
          </div>
        </div>
      )}

      {meta.error && meta.touched && (
        <span className="help-block text-danger">{meta.error}</span>
      )}
    </div>
  );
};

export default AITextField;
